export default class Constraint {
  static get tokenKey(): string {
    return "saas-userToken";
  }
  static get companyIdKey(): string {
    return "currentCompanyId";
  }
  static get companyListKey(): string {
    return "companyList";
  }
  static get userIdKey(): string {
    return "currentUserId";
  }
  static get currentPageSize(): string {
    return "currentPageSize";
  }
}
